import { render, staticRenderFns } from "./CardCampaign.vue?vue&type=template&id=7bbe9fd2"
import script from "./CardCampaign.vue?vue&type=script&lang=js"
export * from "./CardCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/srv/app/components/picture/Picture.vue').default,Icon: require('/srv/app/components/icon/Icon.vue').default})
